module.exports = __webpack_public_path__ + "static/media/committee.107589ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/committee.jpg
// module id = 386
// module chunks = 0